import { useEffect, useState } from 'react'
import { Col, Modal, Form, Row } from 'react-bootstrap'
import CustomCloseButton from '../../Button/CustomCloseButton'
import CustomButton from '../../Button/CustomButton'
import Label from '../../../components/Label/Input'
import { Formik } from 'formik'
import { UpdateRequestSjSchema } from '../../../utils/validationSchema'
import SelectInput from '../../../components/Input/SelectInput'
import TextField from '../../../components/Input/TextInput'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'

function ModalUpdateRequest(props) {
  const { data, refreshData, show, dataRequest } = props
  const [optionItems, setOptionItems] = useState([])
  const [optionBatches, setOptionBatches] = useState([])
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const getBatches = async (warehouse, item_code) => {
    try {
      if (item_code === '') {
        setOptionBatches([])
        return
      }
      const payload = {
        src: warehouse,
        item_code: item_code,
        request_id: data?.request_id
      }
      const res = await api.post('/outbound/sjdraft/show-batch', payload)
      const { data: resData } = res
      if (resData.success) {
        setOptionBatches(
          resData.data.map((batch) => {
            return {
              ...batch,
              value: batch.batch_id,
              label: batch.batch
            }
          })
        )
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(err)
    }
  }
  const getDataItems = async () => {
    try {
      const params = {
        sj: data?.sjCode
      }
      const res = await api.get('/outbound/sjdraft/show-items', { params })
      const { data: dataResponse } = res
      if (dataResponse.success) {
        setOptionItems(
          dataResponse.data.map((item) => {
            return {
              ...item,
              value: item.item_code,
              label: item.item_name
            }
          })
        )
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(err)
    }
  }

  const handleGetData = async () => {
    if (data?.item_code) {
      setOptionItems((prevOptionItem) => [
        ...prevOptionItem,
        { value: data?.item_code, label: data?.item_name }
      ])
      await getBatches(data?.warehouse, data?.item_code)
    } else {
      await getDataItems()
    }
  }

  const handleSubmit = async (values) => {
    try {
      const dataExistCommand = dataRequest.find(
        (request) =>
          request.item_code === values.item_code &&
          request.batch ===
            optionBatches.find((batch) => batch.value === values.batch_id)
              ?.batch
      )
      if (dataExistCommand && !data?.item_code) {
        Common.showPopUpErrorMessage(
          'Item already exists, we recommend to update the quantity instead'
        )
        return false
      }
      setLoadingSubmit(true)
      if (
        !optionBatches.find((batch) => batch.value === values.batch_id)?.slot_id
      ) {
        Common.showPopUpErrorMessage('Slot is required')
        return false
      }
      const payload = {
        batch_id: values.batch_id,
        slot_id: optionBatches.find((batch) => batch.value === values.batch_id)
          ?.slot_id,
        total_pack: Number(values.total_pack)
      }
      let res = ''
      if (data?.item_code) {
        res = await api.post(
          `/outbound/sjdraft/${data?.sjDraftId}/so/${data?.request_id}`,
          payload
        )
      } else {
        res = await api.post(`outbound/sjdraft/${data?.sjDraftId}/so`, {
          ...payload,
          item_alias: optionItems.find(
            (item) => item.item_code === values.item_code
          )?.item_alias
        })
      }
      const { data: dataResponse } = res
      if (dataResponse.success) {
        const message = data?.item_code
          ? 'Successfully updated request'
          : 'Successfully added request'
        Common.showPopUpSuccessMessage(message)
        props.onHide()
        refreshData()
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingSubmit(false)
    }
  }

  const textSubmit = () => {
    if (loadingSubmit) {
      return 'Loading...'
    }
    return data?.item_code !== '' ? 'Update' : 'Add'
  }

  const handleCloseModal = () => {
    props.onHide()
    setOptionBatches([])
    setOptionItems([])
  }

  useEffect(() => {
    if (show) {
      handleGetData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])
  return (
    <>
      <Modal {...props} centered onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <div className="d-flex flex-column justify-content-center mt-2">
            <h5 className="fw-bold text-uppercase" style={{ fontSize: '14px' }}>
              {data.item_code !== '' ? 'Update' : 'Add'} Item
            </h5>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              item_code: data?.item_code || '',
              item_alias: data?.item_alias || '',
              batch_id: '',
              total_pack: 0,
              exp_date: '',
              total_pack_batch: 0
            }}
            validationSchema={UpdateRequestSjSchema}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={(values) => {
              handleSubmit(values)
            }}
          >
            {({
              handleBlur,
              handleSubmit,
              handleChange,
              values,
              errors,
              touched,
              isValid,
              dirty,
              setFieldValue
            }) => {
              return (
                <Form className="d-grid gap-2" onSubmit={handleSubmit}>
                  <Row>
                    <Col md={12}>
                      <SelectInput
                        label="item"
                        name="item_code"
                        id="item_code"
                        value={values.item_code}
                        handleChange={(e) => {
                          const { value } = e.target
                          setFieldValue('item_code', value)
                          setFieldValue(
                            'item_alias',
                            optionItems.find((item) => item.item_code === value)
                              ?.item_alias ?? ''
                          )
                          getBatches(data?.warehouse, value)
                        }}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        options={optionItems}
                        required={true}
                        disabled={data?.item_code !== ''}
                        styles={{ height: '45px' }}
                      />
                    </Col>
                    <Label
                      label="ITEM ALIAS"
                      value={values.item_alias}
                      col={12}
                      classNameValue="fw-bold text-muted"
                    />
                    <Col md={6}>
                      <SelectInput
                        label="Batch"
                        name="batch_id"
                        id="batch_id"
                        value={values.batch_id}
                        handleChange={(e) => {
                          const { value } = e.target
                          setFieldValue('batch_id', value)
                          if (
                            value === '' ||
                            (value !== values.batch_id &&
                              values.batch_id !== '')
                          ) {
                            setFieldValue('total_pack', '')
                            setFieldValue('qty', '')
                            setFieldValue('total_pack_batch', 0)
                          } else {
                            setFieldValue(
                              'exp_date',
                              optionBatches.find(
                                (batch) => batch.value === value
                              )?.expired_date ?? '-'
                            )
                            setFieldValue(
                              'total_pack_batch',
                              optionBatches.find(
                                (batch) => batch.value === value
                              )?.total_pack ?? 0
                            )
                          }
                        }}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        options={optionBatches}
                        required={true}
                        disabled={values.item_code === ''}
                        styles={{ height: '45px' }}
                      />
                    </Col>
                    <Label
                      label="EXP DATE"
                      value={values.exp_date}
                      col={6}
                      classNameValue="fw-bold text-muted"
                    />
                    <Col md={6}>
                      <TextField
                        label="Pack"
                        type="number"
                        name="total_pack"
                        value={values.total_pack}
                        handleChange={(e) => {
                          setFieldValue(
                            'total_pack',
                            e.target.value > 0 ? parseInt(e.target.value) : ''
                          )
                          setFieldValue(
                            'qty',
                            Number(e.target.value) *
                              Number(
                                optionBatches.find(
                                  (batch) => batch.value === values.batch_id
                                )?.convertion_factor_pack || 0
                              )
                          )
                        }}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        placeholder="Enter Pack..."
                        required={true}
                        disabled={values.batch_id === ''}
                        styles={{ height: '45px' }}
                      />
                    </Col>
                    <Label
                      label="QTY"
                      value={values.qty}
                      col={6}
                      classNameValue="fw-bold text-muted"
                    />
                  </Row>
                  <Modal.Footer className="mt-3">
                    <CustomCloseButton
                      text={'Cancel'}
                      onClick={handleCloseModal}
                    />
                    <CustomButton
                      onClick={handleSubmit}
                      variant={
                        !isValid || !dirty || loadingSubmit
                          ? 'secondary'
                          : 'transparent'
                      }
                      classNameValue={
                        !isValid || !dirty || loadingSubmit
                          ? 'opacity-25'
                          : 'btn-primary-orange'
                      }
                      disabled={!isValid || !dirty || loadingSubmit}
                      text={textSubmit()}
                    />
                  </Modal.Footer>
                </Form>
              )
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default ModalUpdateRequest
